import { useMemo } from 'react';

import useSelector from '@app/hooks/useSelector';

import DropdownContent from './DropdownContent';
import NavigationBlock from './NavigationBlock';
import makeNavigationMapSelector from './selectors';

export interface NavigationBlockContainerProps {
    collapsed: boolean;
    projectId: string;
}

const NavigationBlockContainer = ({ collapsed, projectId }: NavigationBlockContainerProps) => {
    const getNavigationMap = useMemo(makeNavigationMapSelector, []);
    const navigation = useSelector((state) => getNavigationMap(state, projectId));

    const renderNavigation = navigation.filter((item) => item.visible).length > 0;

    return (renderNavigation && <NavigationBlock collapsed={collapsed} navigation={navigation} />) || null;
};

export { DropdownContent };

export default NavigationBlockContainer;
